import React from 'react';
import hexToRgba from 'hex-to-rgba';

import colours from '~/utils/colours';
import Replaceable from '~/components/higher-order/ReplaceableComponents';
import Styleable, {
  createStyledComponent,
} from '~/App/Components/HOC/Styleable';

export const styles = {
  item: ({ props }) => ({
    border: 'none',
    outline: 'none',
    borderBottom: `1px solid ${colours.greyMedium}`,
    margin: 0,
    padding: '10px 15px',
    fontSize: '1em',
    color: colours.textFormControl,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: props.active ? hexToRgba(colours.blue, 0.2) : null,
    cursor: props.onClick != null ? 'pointer' : 'default',

    '&:hover': {
      textDecoration: 'none',
      backgroundColor: props.active
        ? hexToRgba(colours.blue, 0.2)
        : colours.formBgGrey,
    },
  }),
};

export const components = {
  Item: createStyledComponent('li', 'item'),
};

@Styleable(styles)
@Replaceable(components)
export default class ListGroupItem extends React.PureComponent {
  render() {
    const { components, styles, ...props } = this.props;
    const { Item } = components;

    return <Item getStyles={this.props.getStyles} {...props} />;
  }
}
